import { FC } from 'react';
import useStore from '@hooks/useStore';
import KushkiCashForm from './KushkiCashForm';
import { PaymentFormProps } from '../types';

const CashPaymentForm: FC<PaymentFormProps> = ({ onValidationError }) => {
  const {
    links: {
      paymentConfig: {
        paymentMethods: { cash },
      },
    },
  } = useStore();

  return (
    <div role="tab-panel" className="tab-content cash-content" data-testid="cash-info-panel">
      <KushkiCashForm onValidationError={onValidationError} apiKey={cash.publicApiKey} />
    </div>
  );
};

export default CashPaymentForm;
